<template>
  <div>
    <v-data-table
      style="margin-inline: 10px"
      class="elevation-5"
      :headers="getHeaderTable(headers)"
      :items="filteredRows"
      :items-per-page="15"
      @update:page="page = $event"
      @update:items-per-page="itemsPerPage = $event"
    >
      <template v-slot:top>
        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            padding-inline: 10px;
          "
        >
          <v-text-field
            v-model="search"
            style="width: 40vh; padding-bottom: 5px"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
          />
          <v-spacer />
          <v-btn
            @click="
              action = 'add';
              selectedWasteType = {};
              windowsForEditOrAdd = true;
            "
          >
            Добавить
          </v-btn>
        </div>
      </template>
      <template v-slot:item.action="{ isMobile, index }">
        <td v-bind:class="!isMobile ? 'v-data-table__divider' : ''">
          <v-icon
            small
            class="mdi-pencil"
            color="#00AAAA"
            title="Изменение записи"
            @click="
              $router.push({
                path: `/edit-waste-type/${searchRowByIndex(index).ID}`,
              })
            "
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mdi-delete"
            color="#FF0000"
            title="Удаление записи"
            @click="
              windowForDelete = true;
              delayedFunction = function () {
                deleteWasteType(searchRowByIndex(index).ID);
              };
            "
          >
            mdi-delete
          </v-icon>
        </td>
      </template>
      <template
        v-for="header in headers"
        v-slot:[`item.${header.value}`]="{ isMobile, item }"
      >
        <td
          :key="header.value"
          v-if="header.type === 'bool'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ item[header.value] ? "Да" : "Нет" }}
        </td>
        <td
          :key="header.value"
          v-else-if="header.type === 'datetime-local'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ dateFormatted(item[header.value]) }}
        </td>
        <td
          :key="header.value"
          v-else-if="header.type === 'color-picker'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          <span
            class="dot"
            :style="`background-color: ${item[header.value]}`"
          ></span>
        </td>
        <td
          :key="header.value"
          v-else
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ item[header.value] }}
        </td>
      </template>
    </v-data-table>
    <!--Форма для редактирования-->
    <v-dialog
      v-if="windowsForEditOrAdd"
      v-model="windowsForEditOrAdd"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{
            action === "update" ? "Редактирование" : "Добавление"
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="isValid" lazy-validation>
            <table class="table-form">
              <tbody>
                <template v-for="(header, index) in headers">
                  <tr
                    v-if="
                      header.showIf != null
                        ? selectedWasteType[header.showIf]
                        : true
                    "
                    :key="index"
                  >
                    <td>
                      <span>{{ header.text }}</span>
                      <v-text-field
                        rows="1"
                        v-if="header.type === 'datetime-local'"
                        outlined
                        :rules="header.rules"
                        type="datetime-local"
                        hide-details
                        no-resize
                        v-model.trim="selectedWasteType[header.value]"
                      ></v-text-field>
                      <v-text-field
                        rows="1"
                        v-if="header.type === 'number'"
                        outlined
                        :rules="header.rules"
                        type="number"
                        hide-details
                        no-resize
                        v-model.number="selectedWasteType[header.value]"
                      ></v-text-field>
                      <v-radio-group
                        v-if="header.type === 'bool'"
                        v-model="selectedWasteType[header.value]"
                        hide-details
                      >
                        <v-radio :label="`Да`" :value="true"></v-radio>
                        <v-radio :label="`Нет`" :value="false"></v-radio>
                      </v-radio-group>
                      <v-textarea
                        v-if="header.type === 'text'"
                        :rules="header.rules"
                        rows="2"
                        outlined
                        v-model.trim="selectedWasteType[header.value]"
                      ></v-textarea>
                      <v-color-picker
                        v-if="header.type === 'color-picker'"
                        mode="rgba"
                        hide-mode-switch
                        v-model="selectedWasteType[header.value]"
                      ></v-color-picker>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="
              windowsForEditOrAdd = false;
              $router.push({
                path: `/edit-waste-type`,
              });
            "
          >
            Отмена
          </v-btn>
          <v-btn
            :disabled="!isValid"
            color="blue darken-1"
            text
            @click="editOrAddRow()"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Оповещение об удалении -->
    <v-dialog
      v-if="windowForDelete"
      v-model="windowForDelete"
      width="400"
      persistent
    >
      <v-card>
        <v-alert type="warning" :value="true"> Внимание</v-alert>
        <v-card-text class="text-md-center">
          Вы действительно хотите удалить данную строку?
        </v-card-text>
        <v-card-actions class="text-lg-right">
          <v-spacer />
          <v-btn
            @click="
              delayedFunction();
              windowForDelete = false;
            "
          >
            Да
          </v-btn>
          <v-btn
            @click="
              windowForDelete = false;
              delayedFunction = function () {};
            "
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { bus } from "@/main";

export default {
  name: "edit-waste-type",
  data() {
    return {
      selectedWasteType: {},
      isValid: true,
      action: "",
      delayedFunction: function () {},
      windowsForEditOrAdd: false,
      windowForDelete: false,
      headers: [
        {
          text: "Наименование отхода",
          value: "caption",
          divider: true,
          rules: [this.required, this.rulesLength(3)],
          type: "text",
        },
        {
          text: "Имя иконки",
          value: "icon",
          rules: [this.required],
          divider: true,
          type: "text",
        },
        {
          text: "Цвет иконки",
          value: "iconColor",
          rules: [this.required],
          divider: true,
          type: "color-picker",
        },
      ],
      wasteTypes: [],
      search: "",
      page: 1,
      itemsPerPage: 15,
    };
  },
  watch: {
    $route(to) {
      if (
        to.params.id !== undefined &&
        to.params.id !== null &&
        to.params.id !== ""
      ) {
        this.getWasteType(to.params.id);
        this.action = "update";
        this.windowsForEditOrAdd = true;
      } else {
        this.selectedWasteType = {};
        this.windowsForEditOrAdd = false;
        this.action = "";
      }
      this.wasteTypes.length <= 0 ? this.getAllWasteTypes() : null;
    },
  },
  computed: {
    filteredRows() {
      if (this.wasteTypes != null) {
        let filteredRows = [];
        if (this.search.length < 3 || this.search === "") {
          filteredRows = this.wasteTypes;
          return filteredRows;
        }
        // eslint-disable-next-line no-unused-vars
        this.wasteTypes.forEach((row) => {
          // eslint-disable-next-line no-unused-vars
          for (const value in row) {
            if (
              row[value]
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase(), 0)
            ) {
              filteredRows.push(row);
              break;
            }
          }
        });
        return filteredRows;
      }
      return [];
    },
  },
  methods: {
    dateFormatted(date) {
      if (date == null) {
        return;
      }
      date = date.replace("T", " ");
      date = date.replace("Z", "");
      return date;
    },
    required: (v) => {
      return !!v || "Это обязательное поле";
    },
    rulesLength: (count) => (v) => {
      if (Array.isArray(v) || typeof v == "string") {
        return (
          v.length > count || "Должно быть не менее " + count + " элементов"
        );
      }
      return true;
    },
    getHeaderTable: function (headers) {
      return [
        {
          text: "Действия",
          value: "action",
          sortable: false,
          divider: true,
        },
        ...headers,
      ];
    },
    editOrAddRow() {
      if (!this.$refs.form.validate()) {
        bus.$emit("message", {
          message: "Информация некорректна",
          color: "red",
        });
        return;
      }
      // eslint-disable-next-line no-unused-vars
      for (const key in this.selectedWasteType) {
        if (this.selectedWasteType[key].toString().trim() === "") {
          this.selectedWasteType[key] = null;
        }
      }
      let WasteType = Object.assign({}, this.selectedWasteType);
      WasteType.iconColor = this.convertColorToBack(WasteType.iconColor.rgba);
      axios
        .post(`/api/waste-type/${this.action}`, WasteType)
        .then(() => {
          this.$router.push({ path: "/edit-waste-type" });
          this.selectedWasteType = {};
          this.windowsForEditOrAdd = false;
          this.action = "";
          this.getAllWasteTypes();
          bus.$emit("message", {
            message: "Сохранено",
            color: "green",
          });
        })
        .catch((e) => {
          if (e.response.status === 401 || e.response.status === 403) {
            bus.$emit("message", {
              message: "Доступ запрещен",
              color: "red",
            });
            return;
          }
          bus.$emit("message", {
            message: "Не удалось внести изменения",
            color: "red",
          });
        });
    },
    // возвращает строчку из уже отфильрованных строк по индексу в таблице
    searchRowByIndex: function (index) {
      if (this.filteredRows.length === 0) {
        return null;
      }
      return this.filteredRows[(this.page - 1) * this.itemsPerPage + index];
    },
    convertColorFront(color) {
      if (color == null) {
        return;
      }
      color = color.substring(4, color.length - 1);
      color = color.split(",");
      console.log({ r: color[0], g: color[1], b: color[2], a: "1" });
      return { r: color[0], g: color[1], b: color[2], a: "1" };
    },
    convertColorToBack(color) {
      // {r: 1, g: 2, b: 3} - > rgb(1,2,3)
      if (color == null) {
        return;
      }
      console.log(`rgb(${color.r},${color.g},${color.b})`);
      return `rgb(${color.r},${color.g},${color.b})`;
    },
    getAllWasteTypes() {
      axios
        .post("api/waste-type/get/all")
        .then((wasteTypeData) => {
          this.wasteTypes = wasteTypeData.data;
        })
        .catch((e) => {
          if (e.response.status === 401 || e.response.status < 403) {
            bus.$emit("message", {
              message: "Доступ запрещен",
              color: "red",
            });
            return;
          }
          bus.$emit("message", {
            message: "Не удалось получить типы отходов",
            color: "red",
          });
        });
    },
    deleteWasteType(id) {
      axios
        .post("api/waste-type/delete", {}, { params: { id: id } })
        .then(() => {
          this.getAllWasteTypes();
          bus.$emit("message", {
            message: "Тип отхода удалена",
            color: "green",
          });
        })
        .catch((e) => {
          if (e.response.status === 401 || e.response.status < 403) {
            bus.$emit("message", {
              message: "Доступ запрещен",
              color: "red",
            });
            return;
          }
          bus.$emit("message", {
            message: "Не удалось удалить тип отхода",
            color: "red",
          });
        });
    },
    getWasteType: function (id) {
      return new Promise((resolve, reject) => {
        axios
          .post("api/waste-type/get", {}, { params: { id: id } })
          .then((wasteTypeData) => {
            this.selectedWasteType = wasteTypeData.data;
            this.selectedWasteType.iconColor = this.convertColorFront(
              this.selectedWasteType.iconColor
            );
            resolve();
          })
          .catch((e) => {
            if (e.response.status === 401 || e.response.status < 403) {
              bus.$emit("message", {
                message: "Доступ запрещен",
                color: "red",
              });
              reject();
              return;
            }
            bus.$emit("message", {
              message: "Не удалось получить тип отхода",
              color: "red",
            });
            reject();
          });
      });
    },
  },
  async mounted() {
    if (this.$route.params.id !== undefined) {
      await this.getWasteType(this.$route.params.id);
      this.action = "update";
      this.windowsForEditOrAdd = true;
    }
    this.getAllWasteTypes();
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
}

.table-form {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  height: auto;
}

.table-form td,
th {
  word-wrap: break-word;
  padding: 5px;
}

v-textarea {
  height: 100%;
}

.dot {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
}
</style>
